/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'import': {
    width: 800,
    height: 800,
    viewBox: '0 0 36 36',
    data: '<path pid="0" d="M6 13.61h7.61V6H24v8.38h2V6a2 2 0 00-2-2H10.87L4 10.87V30a2 2 0 002 2h18a2 2 0 002-2H6zm0-1.92L11.69 6H12v6H6z" class="clr-i-outline clr-i-outline-path-1"/><path pid="1" d="M28.32 16.35a1 1 0 00-1.41 1.41L30.16 21H18a1 1 0 000 2h12.19l-3.28 3.28a1 1 0 101.41 1.41L34 22z" class="clr-i-outline clr-i-outline-path-2"/><path pid="2" fill-opacity="0" d="M0 0h36v36H0z"/>'
  }
})
